import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import * as QuickLinkCardComponent from './quick-links-card';
import * as CallToActionCardComponent from './call-to-action-card';
import * as HippoHomeCareCardComponent from './hippo-home-care-card';
import * as RenewalCardComponent from './renewal-card';
import * as AppDownloadCardComponent from './app-download-card';
import { CurrentUserService } from 'services/currentUser';
import { TransitionService } from '@uirouter/angularjs';
import { shouldShowCta } from 'utilities/paymentsHelper';

import * as _ from 'lodash';
import { isMobile } from 'utilities/devices';

const module = angular.module('sidebar', [
    QuickLinkCardComponent.module.name,
    CallToActionCardComponent.module.name,
    HippoHomeCareCardComponent.module.name,
    RenewalCardComponent.module.name,
    AppDownloadCardComponent.module.name
]);

interface SidebarController extends angular.IStrictController {
    showQuickLinksCard: boolean;
    showCallToActionCard: boolean;
    showRenewalCard: boolean;
    showMobileAppDownloadCard: boolean;
    hideQuickLinks: boolean;
    hideCallToAction: boolean;
    policyInfos: Array<CustomerPolicyInfo>;
}

module.component('sidebar', {
    template: template,
    bindings: {
        hideQuickLinks: '<',
        hideCallToAction: '<',
        showMobileAppDownloadCard: '&'
    },
    controller: function(
        this: SidebarController,
        $transitions: TransitionService,
        $stateParams: StateParams,
        $rootScope: angular.IRootScopeService,
        currentUserService: CurrentUserService,
        $scope: angular.IScope
    ) {
        this.$onInit = () => {
            this.showQuickLinksCard = !this.hideQuickLinks;
            this.showMobileAppDownloadCard = !isMobile();

            const updateCustomerPolicyInfo = (policyIndex?: RoutePolicyIndex) => {
                if (policyIndex) {
                    currentUserService.getCustomerPolicyInfoByIndex(policyIndex).then((policyInfo) => {
                        const showCta = shouldShowCta(policyInfo, 'sidebar');
                        this.showCallToActionCard = !this.hideCallToAction && showCta;

                        this.showRenewalCard = !!policyInfo.aggregate_documents.next_renewal_offer;
                    });
                }
            };

            $transitions.onSuccess({}, (transition) => {
                updateCustomerPolicyInfo(transition.params().policyIndex);
            });

            updateCustomerPolicyInfo($stateParams.policyIndex);

            const deregisterRootScopeListener = $rootScope.$on('updatedCustomerPolicyInfos', () => {
                updateCustomerPolicyInfo($stateParams.policyIndex);
            });

            $scope.$on('$destroy', () => {
                deregisterRootScopeListener();
            });
        };
    }
});

export { module };
